import { z } from 'zod/v4'
import { companyContactSchema } from './company-contact'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { tenantSchema } from '@/lib/schema/v2/tenant'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const typeSchema = z.object({
    created_at: zDayJs.nullish(),
    name: z.string().nullish(),
    title: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const companySchema = z.object({
    abn: z.string().nullish(),
    articles_count: z.number().nullish(),
    assets_count: z.number().nullish(),
    balance_for_human: z.string().nullish(),
    balance_in_cents: z.number().nullish(),
    billing_type: z.string().nullish(),
    contacts: z.lazy(() => z.array(companyContactSchema).nullish()),
    contacts_count: z.number().nullish(),
    created_at: zDayJs.nullish(),
    credit_in_cents: z.number().nullish(),
    credit_for_human: z.string().nullish(),
    current_due_in_cents: z.number().nullish(),
    current_due_for_human: z.string().nullish(),
    default_contact: z.lazy(() => companyContactSchema.nullish()),
    default_contact_uuid: z.uuid().nullish(),
    initials: z.string().nullish(),
    invoice_email_template_uuid: z.uuid().nullish(),
    invoice_location_uuid: z.uuid().nullish(),
    is_active: z.boolean().nullish(),
    is_autopay: z.boolean().nullish(),
    locations_count: z.number().nullish(),
    name: z.string().nullish(),
    note: z.string().nullish(),
    number: z.number().nullish(),
    outstanding_invoices_pdf_url: z.url().nullish(),
    overdue_in_cents: z.number().nullish(),
    overdue_for_human: z.string().nullish(),
    prefix: z.string().nullish(),
    receipt_email_template_uuid: z.uuid().nullish(),
    secrets_count: z.number().nullish(),
    services_count: z.number().nullish(),
    tenant: tenantSchema.nullish(),
    tenant_uuid: z.uuid().nullish(),
    tickets_count: z.number().nullish(),
    title: z.string().nullish(),
    type: z.lazy(() => typeSchema.nullish()),
    type_uuid: z.uuid().nullish(),
    updated_at: zDayJs.nullish(),
    uuid: z.uuid().nullish(),
})

export const companiesSchema = z.array(companySchema)

export const paginatedCompaniesResponseSchema = z.object({
    data: companiesSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveCompanyResponseSchema = z.object({
    data: companySchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const createCompanyResponseSchema = z.object({
    data: companySchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const companyUpdateFormSchema = z.object({})

export type Company = z.infer<typeof companySchema>
export type Companies = z.infer<typeof companiesSchema>
export type PaginatedCompaniesResponse = z.infer<typeof paginatedCompaniesResponseSchema>
export type CompanyUpdateForm = z.infer<typeof companyUpdateFormSchema>
export type RetrieveCompanyResponse = z.infer<typeof retrieveCompanyResponseSchema>
export type CreateCompanyResponse = z.infer<typeof createCompanyResponseSchema>
